// export const parseTelemetry = (res) => {
//   const raw = res?.data?.data?.[0]?.value;
//   if (!raw) return null;   // fail gracefully

import { nil } from "ajv";

//   const parsed = JSON.parse(raw);
//   const m = parsed.modbus?.[0];
//   if (!m) return null;

//   return {
//     pressures: {
//       upperHyd: m.Upp_Hyd_Pr / 100,
//       lowerHyd: m.Low_Hyd_Pr / 100,
//       upperSpr: m.Upp_Spr_Pr / 100,
//       lowerSpr: m.Low_Spr_Pr / 100,
      
//     },

//     status: [
//       { label: "Hyd Pump", val: m.Hyd_Pump_Sts },
//       { label: "Hyd Pump Trip", val: m.Hyd_Pump_Tr },
//       { label: "Hyd Pump Mode", val: m.Hyd_Pump_Mod },

//       { label: "Spr Pump", val: m.Spr_Pump_Sts },
//       { label: "Spr Pump Trip", val: m.Spr_Pump_Tr },
//       { label: "Spr Pump Mode", val: m.Spr_Pump_Mod },

//       { label: "Hyd Jockey", val: m.Hyd_JP_Sts },
//       { label: "Spr Jockey", val: m.Spr_JP_Sts },

//     //   { label: "Engine Fault", val: m.Eng_DP1_Fault },
//     //   { label: "Fuel Low", val: m.Fuel_Low_Level }
//     ],

//     tanks: {
//       upper: m.Upp_Tank_L_M ? 50 : m.Upp_Tank_L_L ? 20 : 90,
//       water: m.Water_L_M ? 50 : m.Water_L_L ? 20 : 90
//     }
//   };
// };



// src/api/telemetryparser.js
// all cards visible
// export const parseTelemetry = (res) => {
//   const raw = res?.data?.[0]?.value || res?.data?.data?.[0]?.value;
//   if (!raw) return null;

//   const parsed = JSON.parse(raw);
//   const m = parsed.modbus?.[0];
//   if (!m) return null;

// const getTankData = (prefix) => {
//     if (m[`${prefix}_H`] === 1) return { level: 100, color: "#3b82f6" }; // Blue
//     if (m[`${prefix}_M`] === 1) return { level: 50, color: "#eab308" };  // Yellow
//     if (m[`${prefix}_L`] === 1) return { level: 25, color: "#ef4444" };  // Red
//     return { level: 10, color: "#64748b" }; // Empty/Unknown
//   };

//   return {
//     pressures: {
//       upperHyd: m.Upp_Hyd_Pr,
//       lowerHyd: m.Low_Hyd_Pr,
//       upperSpr: m.Upp_Spr_Pr,
//       lowerSpr: m.Low_Spr_Pr,
//     },
//     status: [
//       // PUMPS (Status)
//       { label: "Hydrant Pump", val: m.Hyd_Pump_Sts === 1 ? "RUNNING" : "STOPPED", type: "status", active: m.Hyd_Pump_Sts === 1 },
//       { label: "Sprinkler Pump", val: m.Spr_Pump_Sts === 1 ? "RUNNING" : "STOPPED", type: "status", active: m.Spr_Pump_Sts === 1 },
//       { label: "Hydrant Jockey", val: m.Hyd_JP_Sts === 1 ? "RUNNING" : "STOPPED", type: "status", active: m.Hyd_JP_Sts === 1 },
//       { label: "Engine Pump", val: m.Eng_DP1_Sts === 1 ? "RUNNING" : "STOPPED", type: "status", active: m.Eng_DP1_Sts === 1 },
      
//       // TRIPS & FAULTS
//       { label: "Hydrant Trip", val: m.Hyd_Pump_Tr === 1 ? "TRIPPED" : "OK", type: "trip", active: m.Hyd_Pump_Tr === 1 },
//       { label: "Sprinkler Trip", val: m.Spr_Pump_Tr === 1 ? "TRIPPED" : "OK", type: "trip", active: m.Spr_Pump_Tr === 1 },
//       { label: "Engine Fault", val: m.Eng_DP1_Fault === 1 ? "FAULT" : "OK", type: "trip", active: m.Eng_DP1_Fault === 1 },
//       { label: "Fuel Level", val: m.Fuel_Low_Level === 1 ? "LOW" : "OK", type: "trip", active: m.Fuel_Low_Level === 1 },

//       // MODES & SELECTION
//       { label: "Hydrant Mode", val: m.Hyd_Pump_Mod === 1 ? "AUTO" : "MANUAL", type: "mode" },
//       { label: "Engine Mode", val: m.Eng_DP1_Mod === 1 ? "AUTO" : "MANUAL", type: "mode" },
//       { label: "Jockey Selection", val: m.Jock_Pump_Sel === 1 ? "SELECTED" : "NOT SELECTED", type: "mode" },
//       { label: "Supply Health", val: m.Supply_H === 1 ? "HEALTHY" : "UNHEALTHY", type: "mode", active: m.Supply_H === 1 },
//     ],
//     tanks: {
//       main: getTankData("Water_L"),
//       upper: getTankData("Upp_Tank_L")
//     }
//   };
// };




// export const parseTelemetry = (res) => {
//   // const raw = res?.data?.[0]?.value || res?.data?.data?.[0]?.value;
//   const raw = res?.data?.modbus?.[0]?.value;
//   if (!raw) return null;

//   const parsed = JSON.parse(raw);
//   const m = parsed.modbus?.[0];
//   if (!m) return null;

//   const getTank = (prefix) => {
//     if (m[`${prefix}_H`] === 1) return { level: 100, color: "#008cff" };
//     if (m[`${prefix}_M`] === 1) return { level: 50, color: "#eab308" };
//     if (m[`${prefix}_L`] === 1) return { level: 25, color: "#ff3e3e" };
//     return { level: 10, color: "#4a5568" };
//   };

//   return {
//     pressures: {
//       upperHyd: m.Upp_Hyd_Pr,
//       lowerHyd: m.Low_Hyd_Pr,
//       upperSpr: m.Upp_Spr_Pr,
//       lowerSpr: m.Low_Spr_Pr,
//     },
//     status: [
//       // HYDRANT PUMP GROUP
//       { label: "Hydrant Pump", val: m.Hyd_Pump_Sts === 1 ? "RUNNING" : "STOPPED", category: "hydrant", active: m.Hyd_Pump_Sts === 1 },
//       { label: "Hydrant Trip", val: m.Hyd_Pump_Tr === 1 ? "TRIPPED" : "OK", category: "hydrant", active: m.Hyd_Pump_Tr === 1, type: "trip" },
//       { label: "Hydrant Mode", val: m.Hyd_Pump_Mod === 1 ? "AUTO" : "MANUAL", category: "hydrant" },

//       // SPRINKLER PUMP GROUP
//       { label: "Sprinkler Pump", val: m.Spr_Pump_Sts === 1 ? "RUNNING" : "STOPPED", category: "sprinkler", active: m.Spr_Pump_Sts === 1 },
//       { label: "Sprinkler Trip", val: m.Spr_Pump_Tr === 1 ? "TRIPPED" : "OK", category: "sprinkler", active: m.Spr_Pump_Tr === 1, type: "trip" },
//       { label: "Sprinkler Mode", val: m.Spr_Pump_Mod === 1 ? "AUTO" : "MANUAL", category: "sprinkler" },

//       // JOCKEY PUMP GROUP
//       { label: "Hyd Jockey", val: m.Hyd_JP_Sts === 1 ? "RUNNING" : "STOPPED", category: "jockey", active: m.Hyd_JP_Sts === 1 },
//       { label: "Spr Jockey", val: m.Spr_JP_Sts === 1 ? "RUNNING" : "STOPPED", category: "jockey", active: m.Spr_JP_Sts === 1 },
//       { label: "Jockey Selection", val: m.Jock_Pump_Sel === 1 ? "SELECTED" : "NOT SELECTED", category: "jockey" },

//       // ENGINE PUMP GROUP
//       { label: "Engine Pump", val: m.Eng_DP1_Sts === 1 ? "RUNNING" : "STOPPED", category: "engine", active: m.Eng_DP1_Sts === 1 },
//       { label: "Engine Fault", val: m.Eng_DP1_Fault === 1 ? "FAULT" : "OK", category: "engine", active: m.Eng_DP1_Fault === 1, type: "trip" },
//       { label: "Engine Mode", val: m.Eng_DP1_Mod === 1 ? "AUTO" : "MANUAL", category: "engine" },
//       { label: "Fuel Level", val: m.Fuel_Low_Level === 1 ? "LOW" : "OK", category: "engine", active: m.Fuel_Low_Level === 1, type: "trip" },
//       { label: "Supply Health", val: m.Supply_H === 1 ? "HEALTHY" : "WEAK", category: "engine", active: m.Supply_H === 1 }
//     ],
//     tanks: {
//       main: getTank("Water_L"),
//       upper: getTank("Upp_Tank_L")
//     }
//   };
// };


// export const parseTelemetry = (res) => {
//   const t = res?.data;
//   if (!t) return null;

//   const getVal = (key) => Number(t[key]?.[0]?.value || 0);

//   const getTank = (H, M, L) => {
//     if (getVal(H) === 1) return { level: 100, color: "#008cff" };
//     if (getVal(M) === 1) return { level: 50, color: "#eab308" };
//     if (getVal(L) === 1) return { level: 25, color: "#ff3e3e" };
//     return { level: 10, color: "#4a5568" };
//   };

//   return {
//     pressures: {
//       upperHyd: getVal("Upp_Hyd_Pr"),
//       lowerHyd: getVal("Low_Hyd_Pr"),
//       upperSpr: getVal("Upp_Spr_Pr"),
//       lowerSpr: getVal("Low_Spr_Pr"),
//     },

//     status: [
//       { label: "Hydrant Pump", val: getVal("Hyd_Pump_Sts") ? "RUNNING" : "STOPPED", category: "hydrant", active: getVal("Hyd_Pump_Sts") },
//       { label: "Hydrant Trip", val: getVal("Hyd_Pump_Tr") ? "TRIPPED" : "OK", category: "hydrant", active: getVal("Hyd_Pump_Tr"), type: "trip" },
//       { label: "Hydrant Mode", val: getVal("Hyd_Pump_Mod") ? "AUTO" : "MANUAL", category: "hydrant" },

//       { label: "Sprinkler Pump", val: getVal("Spr_Pump_Sts") ? "RUNNING" : "STOPPED", category: "sprinkler", active: getVal("Spr_Pump_Sts") },
//       { label: "Sprinkler Trip", val: getVal("Spr_Pump_Tr") ? "TRIPPED" : "OK", category: "sprinkler", active: getVal("Spr_Pump_Tr"), type: "trip" },
//       { label: "Sprinkler Mode", val: getVal("Spr_Pump_Mod") ? "AUTO" : "MANUAL", category: "sprinkler" },

//       { label: "Hyd Jockey", val: getVal("Hyd_JP_Sts") ? "RUNNING" : "STOPPED", category: "jockey", active: getVal("Hyd_JP_Sts") },
//       { label: "Spr Jockey", val: getVal("Spr_JP_Sts") ? "RUNNING" : "STOPPED", category: "jockey", active: getVal("Spr_JP_Sts") },
//       { label: "Jockey Selection", val: getVal("Jock_Pump_Sel") ? "SELECTED" : "NOT SELECTED", category: "jockey" },

//       { label: "Engine Pump", val: getVal("Eng_DP1_Sts") ? "RUNNING" : "STOPPED", category: "engine", active: getVal("Eng_DP1_Sts") },
//       { label: "Engine Fault", val: getVal("Eng_DP1_Fault") ? "FAULT" : "OK", category: "engine", active: getVal("Eng_DP1_Fault"), type: "trip" },
//       { label: "Engine Mode", val: getVal("Eng_DP1_Mod") ? "AUTO" : "MANUAL", category: "engine" },
//       // { label: "Fuel Level", val: getVal("Fuel_Low_Level") ? "LOW" : "OK", category: "engine", active: getVal("Fuel_Low_Level"), type: "trip" },
//       // { label: "Supply Health", val: getVal("Supply_H") ? "HEALTHY" : "WEAK", category: "engine", active: getVal("Supply_H") }
//     ],

//     tanks: {
//       main: getTank("Water_L_H", "Water_L_M", "Water_L_L"),
//       upper: getTank("Upp_Tank_L_H", "Upp_Tank_L_M", "Upp_Tank_L_L")
//     }
//   };
// };
// perfect data parsing



export const parseTelemetry = (res) => {
  // Access the stringified JSON from the value field
  const t = res?.data;
  if (!t) return null;


  const formatDTM = (dtm) => {
   
    if (!dtm || typeof dtm !== 'string') return "N/A";
    return `${dtm.slice(6, 8)}-${dtm.slice(4, 6)}-${dtm.slice(0, 4)} ${dtm.slice(8, 10)}:${dtm.slice(10, 12)}:${dtm.slice(12, 14)}`;
  };



 
  try {
 const getVal = (key) => Number(t[key]?.[0]?.value || 0);
 const rawDtm = t["dtm"]?.[0]?.value || "";

    // Tank Level Logic: 100% (High), 50% (Medium), 20% (Low)
    
const getLevel = (H, M, L) => {
      const vH = getVal(H), vM = getVal(M), vL = getVal(L);
      if (vH === null && vM === null && vL === null) return null;
      if (vH === 1) return 100;
      if (vM === 1) return 50;
      if (vL === 1) return 20;
      return 0;
    };

     
    

   return {
    lastUpdated: formatDTM(rawDtm),
      pressures: {
        upperHyd: getVal("Upp_Hyd_Pr")/100,
        lowerHyd: getVal("Low_Hyd_Pr")/100,
        upperSpr: getVal("Upp_Spr_Pr")/100,
        lowerSpr: getVal("Low_Spr_Pr")/100,
      },
      status: [
        // Main Hydrant
        { label: "Status", val: getVal("Hyd_Pump_Sts") ? "ONLINE" : "OFFLINE", category: "hydrant" },
        { label: "Trip", val: getVal("Hyd_Pump_Tr") ? "NOT OK" : "OK", category: "hydrant", active: getVal("Hyd_Pump_Tr") },
        { label: "Mode", val: getVal("Hyd_Pump_Mod") ? "AUTO" : "MANUAL", category: "hydrant" },

        // Main Sprinkler
        { label: "Status", val: getVal("Spr_Pump_Sts") ? "ONLINE" : "OFFLINE", category: "sprinkler" },
        { label: "Trip", val: getVal("Spr_Pump_Tr") ? "NOT OK" : "OK", category: "sprinkler", active: getVal("Spr_Pump_Tr") },
        { label: "Mode", val: getVal("Spr_Pump_Mod") ? "AUTO" : "MANUAL", category: "sprinkler" },

        // Hydrant Jockey (New Separate Category)
        { label: "Status", val: getVal("Hyd_JP_Sts") ? "ONLINE" : "OFFLINE", category: "hyd_jockey" },
        { label: "Trip", val: getVal("Hyd_JP_Tr") ? "NOT OK" : "OK", category: "hyd_jockey", active: getVal("Hyd_JP_Tr") },
        { label: "Mode", val: getVal("Hyd_JP_Mod") ? "AUTO" : "MANUAL", category: "hyd_jockey" },
        

        // Sprinkler Jockey (New Separate Category)
        { label: "Status", val: getVal("Spr_JP_Sts") ? "ONLINE" : "OFFLINE", category: "spr_jockey" },
        { label: "Trip", val: getVal("Spr_JP_Tr") ? "NOT OK" : "OK", category: "spr_jockey", active: getVal("Spr_JP_Tr") },
        

        // Diesel Engine
        { label: "Status", val: getVal("Eng_DP1_Sts") ? "ONLINE" : "OFFLINE", category: "engine" },
        { label: "Fault", val: getVal("Eng_DP1_Fault") ? "NOT OK" : "OK", category: "engine", active: getVal("Eng_DP1_Fault") },
        { label: "Mode", val: getVal("Eng_DP1_Mod") ? "AUTO" : "MANUAL", category: "engine" },

        { 
    label: "Fuel Level", 
    val: getVal("Fuel_Low_Level") === null ? null : (getVal("Fuel_Low_Level") === 1 ? "FULL" : "LOW"), 
    category: "system" 
  },
  { 
    label: "Supply Health", 
    val: getVal("Supply_Health") === null ? null : (getVal("Supply_H") === 1 ? "HEALTHY" : "FAULT"), 
    category: "system" 
  },
  { label: "Selection", val: getVal("Jock_Pump_Sel") ? "SELECTED" : "NOT SELECTED", category: "system" },
      ],
      
      indicators: [
        { label: "Fuel Level", status: getVal("Fuel_Low_Level") === 0 ? "LOW" : "FULL", type: "warning" },
        { label: "Supply Health", status: getVal("Supply_H") === 1 ? "HEALTHY" : "FAULT", type: "health" }
      ],
tanks: [
        { label: "Main Water Tank", level: getLevel("Water_L_H", "Water_L_M", "Water_L_L"), type: 'water' },
        { label: "Diesel Tank", level: getLevel("Upp_Tank_L_H", "Upp_Tank_L_M", "Upp_Tank_L_L"), type: 'diesel' }
      ]
    };
  } catch (e) {
    console.error("Telemetry Parse Error:", e);
    return null;
  }
};

